import React from "react";
import { withRouter } from "react-router-dom";

import Slider from "rc-slider";
import { defineGrid, extendHex, Point } from "honeycomb-grid";

import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";

import equal from "fast-deep-equal";

import Select from "react-select";

import { toast } from "react-toastify";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagic,
  faCheckCircle,
  faChevronRight,
  faChevronLeft,
  faBinoculars,
  faTrash,
  faPlay,
  faSearch
} from "@fortawesome/free-solid-svg-icons";

import { OverlayTrigger, Popover } from "react-bootstrap";

import { Button, ButtonGroup } from "aible";

import FirstVarIcon from "images/Next-Icons/drill-in-2.svg";
import SecondVarIcon from "images/Next-Icons/drill-in-1.svg";
import MicroscopeIcon from "images/Microscope.svg";
import TelescopeIcon from "images/Next-Icons/mode-voting.svg";
import StatAssocIcon from "images/Next-Icons/stats.svg";
import PopularIcon from "images/Next-Icons/mode-voting.svg";
import VotingIcon from "images/Next-Icons/model-voting.svg";
import BackIcon from "images/Next-Icons/BackIcon.svg";
import ExitIcon from "images/Next-Icons/ExitIcon.svg";
import HexagonChevronGrey from "images/Next-Icons/HexagonChevronGrey.svg";
import HexagonChevronPurple from "images/Next-Icons/HexagonChevronPurple.svg";
import TodoAssignIcon from "images/Next-Icons/TodoAssignIcon.svg";
import TodoAddIcon from "images/Next-Icons/TodoAddIcon.svg";
import NextClose from "images/Next-Icons/NextClose.svg";
import LightExpertIcon from "images/Next-Icons/LightExpertIcon.png";

import NodePin from "images/Next-Icons/NodePin.svg";
import NodeExplore from "images/Next-Icons/NodeExplore.svg";

import FullPin from "images/Next-Icons/FullPin.svg";
import EmptyPin from "images/Next-Icons/EmptyPin.svg";

import PinnedIcon from "images/Sense-Icons/pinned.svg";
import UnpinnedIcon from "images/Sense-Icons/unpinned.svg";
import PinnedHoverIcon from "images/Sense-Icons/unpin.svg";

import LeakageChartContainer from "containers/Next/Charts/LeakageChart";
import ComparisonChartContainer from "containers/Next/Charts/ComparisonChart";
import DistributionChartContainer from "containers/Next/Charts/DistributionChart";
import OutcomeChartContainer from "containers/Next/Charts/OutcomeChart";
import DoubleOutcomeChartContainer from "containers/Next/Charts/DoubleOutcomeChart";

import NextChartContainer from "components/Next/Charts/NextChart";
import Heatmap from "components/Next/Charts/Heatmap";

import { CHART_TYPES } from "containers/Report/ReportReducer";
import { HEXAGON_NODES, DIRECTION_NODES, DIRECTION_NODES_SINGLE } from "containers/Next/NextReducer";

import styles from "./style.module.css";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

const HEXAGON_COLOR = "white";
const SELECTED_COLOR = "white";

const colors = [
  "rgba(134, 134, 210, 1)",
  "rgba(223, 154, 80, 1)",
  "rgba(209, 106, 67, 1)",
  "rgba(161, 192, 100)",
  "rgba(102, 102, 102, 1)",
  "rgba(104, 168, 216, 1)"
];

const colorsFaded = [
  "rgba(134, 134, 210, 0.02)",
  "rgba(223, 154, 80, 0.02)",
  "rgba(209, 106, 67, 0.02)",
  "rgba(161, 192, 100, 0.02)",
  "rgba(102, 102, 102, 0.02)",
  "rgba(104, 168, 216, 0.02)"
];

const miniHexSize = 16;

export class InnerHexagon extends React.PureComponent {
  constructor(props) {
    super(props);

    const parent = props?.node?.aParent;

    const point =
      parent && props.getPoint && (props?.node?.isAnimate === true || props?.isAnimate)
        ? props.getPoint(parent.x, parent.y)
        : props.getPoint && props.aTimeout !== undefined && props.stopAnimation !== true
          ? props.getPoint(8, 8)
          : undefined;

    const isAnimateUpdateHover = props.getPoint && props.aTimeout !== undefined && props.stopAnimation !== true;

    this.state = {
      isHover: false,
      left: point ? point.x : props.left,
      top: point ? point.y : props.top,
      isLoadAnimate: isAnimateUpdateHover,
      isAnimateUpdateHover: props?.nextId !== "new" ? false : isAnimateUpdateHover,
      retOpacity: props?.isAnimate === true || true ? 0 : 1
    };
  }

  componentDidMount() {
    const { left, top, aTimeout, node, nodes, updateHover, isFirstChart } = this.props;

    const { isAnimateUpdateHover } = this.state;

    if (isAnimateUpdateHover) {
      this.animateTimeout = setTimeout(() => {
        if (nodes && nodes.length > 0) {
          updateHover(node);
        } else {
          updateHover(node);
        }
        this.setState({
          left: left,
          top: top,
          retOpacity: 1
        });

        if (isFirstChart !== true) {
          setTimeout(() => this.setState({ hideStacked: true }), 1000);
        }

        this.animateTimeout = undefined;
      }, aTimeout);
    } else {
      this.setState({
        left: left,
        top: top,
        retOpacity: 1,
        hideStacked: !isFirstChart
      });
    }
  }

  componentWillUnmount() {
    if (this.animateTimeout !== undefined) {
      clearTimeout(this.animateTimeout);
    }
  }

  componentDidUpdate(prevProps) {
    const { left, top, isSelectedActionHex, nodes, node } = this.props;

    if (isSelectedActionHex !== prevProps.isSelectedActionHex) {
      this.setState({ left: left, top: top });
    }

    if (left !== prevProps.left || top !== prevProps.top) {
      this.setState({ left: left, top: top });
    }
  }

  render() {
    const {
      children,
      opacity,
      zIndex,
      getPoint,
      node,
      useLocation,
      isSelectedActionHex,
      updateHover,
      aTimeout,
      stopAnimation,
      nextChart,
      isAnimate,
      isFirstChart,
      nextId,
      retId,
      id,
      ...retProps
    } = this.props;
    const { left, top, isLoadAnimate, retOpacity, hideStacked } = this.state;

    return (
      <div
        {...retProps}
        id={retId}
        left={undefined}
        top={undefined}
        style={
          useLocation
            ? {}
            : {
                left: left,
                top: top,
                opacity: retOpacity !== undefined ? retOpacity : opacity,
                zIndex: zIndex,
                pointerEvents: isFirstChart ? undefined : "none"
              }
        }
      >
        {children}
        {hideStacked !== true && nextChart}
      </div>
    );
  }
}

export default class Hexagon extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isHover: false,
      isAnimate: props.aTimeout !== undefined ? true : false
    };
  }

  getIconFromType(type) {
    const icon =
      type === HEXAGON_NODES.SECOND_VARIABLE
        ? SecondVarIcon
        : type === HEXAGON_NODES.STAT_ASSOC
          ? StatAssocIcon
          : type === HEXAGON_NODES.POPULAR
            ? PopularIcon
            : type === HEXAGON_NODES.VOTING
              ? VotingIcon
              : type === HEXAGON_NODES.DRILL_IN_CLUSTER
                ? SecondVarIcon
                : type === HEXAGON_NODES.DRILL_IN
                  ? FirstVarIcon
                  : type === HEXAGON_NODES.FIRST_VARIABLE
                    ? FirstVarIcon
                    : FirstVarIcon;

    return icon;
  }

  renderHex(currentField, index, rNodes) {
    const {
      hexSize,
      selectedHex,
      hex,
      node,
      nodes,
      innerHexSize,
      isHighlight,
      isInPath,
      isPinned,
      isInReport,
      isDragHex,
      isSelectedActionHex,
      selectionDirection,
      hasViewed,
      hasActions,
      comparisonOptions,
      selectedChart
    } = this.props;
    const { isHover, isFastHover } = this.state;
    const iNode = rNodes?.[index] || node;

    const firstVariable = comparisonOptions
      ? (Object.values(iNode?.fields ?? {}).find((f) => f?.label !== comparisonOptions.dateField) ?? {})
      : iNode && iNode.fields && iNode.fields[0]
        ? iNode.fields[0]
        : {};
    const secondVariable = !comparisonOptions && iNode && iNode.fields && iNode.fields[1] ? iNode.fields[1] : {};

    const firstColor = iNode?.chart?.metadata?.type === "Correlation" ? iNode?.chart?.color : firstVariable.color;
    const secondColor = secondVariable.color;

    const retInnerHexSize = isDragHex ? innerHexSize / 1.25 : innerHexSize;

    const background =
      node?.type === HEXAGON_NODES.MUSCLE
        ? "white"
        : iNode?.isDirection && iNode.type === HEXAGON_NODES.DRILL_IN
          ? firstColor
          : iNode?.isDirection && iNode.type === HEXAGON_NODES.DRILL_IN_CLUSTER
            ? firstColor
            : iNode?.isDirection
              ? "rgba(126, 105, 215, 1)"
              : isDragHex
                ? "#F2F1FD"
                : isPinned || (hasActions && isInReport && isSelectedActionHex !== true)
                  ? "rgba(230, 229, 250, 1)"
                  : isHighlight
                    ? "white"
                    : hasViewed !== true
                      ? "#F2F3F7"
                      : HEXAGON_COLOR;

    const hoverColor = isDragHex
      ? "#BEB4EB"
      : (node && selectionDirection && selectionDirection.type === node.type) ||
          isInPath ||
          isHighlight ||
          isHover ||
          isFastHover
        ? "rgba(122, 109, 208, 1)"
        : "#C8CAD4";

    return (
      <div>
        <div
          className={styles.hexagon}
          style={{
            height: retInnerHexSize + "px",
            width: retInnerHexSize * (110 / 190) + "px",
            background: background
          }}
        >
          <div
            className={styles.triangle1}
            style={{
              background: firstColor,
              width: secondColor === undefined || firstColor === secondColor ? "100%" : "calc(50% - 1px)"
            }}
          />
          <div className={styles.triangle2} style={{ background: secondColor }} />
          <div
            className={styles.face1}
            style={{
              background: background
            }}
          ></div>
          <div
            className={styles.face2}
            style={{
              background: background
            }}
          ></div>
        </div>
        <div className={styles.borderHex}>
          <div
            className={styles.hexagon}
            style={{
              height: retInnerHexSize + 6 + "px",
              width: retInnerHexSize * (110 / 190) + (6 * 110) / 190 + "px",
              background: hoverColor
            }}
          >
            <div
              className={styles.face1}
              style={{
                background: hoverColor
              }}
            ></div>
            <div
              className={styles.face2}
              style={{
                background: hoverColor
              }}
            ></div>
          </div>
        </div>
      </div>
    );
  }

  renderMiniHex(fields) {
    const { node, nodes, isPreview } = this.props;

    const isDirectionNode = node && node.direction === undefined && DIRECTION_NODES.indexOf(node.type) !== -1;

    const background = node?.borderColor
      ? node.borderColor
      : node?.background
        ? node.background
        : isPreview && node?.afterSetup === undefined && node?.afterText !== undefined
          ? "#F47C20"
          : node?.chart?.color
            ? node?.chart?.color
            : node?.color
              ? node?.color
              : isDirectionNode
                ? "#7E69D7"
                : fields[0]
                  ? fields[0].color
                  : "#7E69D7";

    const sBackground = isDirectionNode
      ? "#7E69D7"
      : fields === undefined
        ? "#7E69D7"
        : fields[1]
          ? fields[1].color
          : node?.color
            ? node?.color
            : background;

    return (
      <div>
        <div
          className={styles.hexagon}
          style={{
            height: miniHexSize - 4 + "px",
            width: (miniHexSize - 4) * (110 / 190) + "px",
            background: background
          }}
        >
          {nodes && nodes.length > 1 && <div className={styles.miniText}>{nodes.length}</div>}
          <div
            className={styles.face1}
            style={{
              background: background
            }}
          ></div>
          <div
            className={styles.face2}
            style={{
              background: background
            }}
          ></div>
        </div>
      </div>
    );
  }

  renderFirst(currentField) {
    const { id, chartType, isDistribution, innerHexSize, hexSize } = this.props;

    return (
      <div className={styles.hexContent}>
        {currentField && (
          <div>
            <div
              className={styles.hexChart}
              style={{
                height: innerHexSize / 1.5 + "px",
                width: innerHexSize / 1.5 + "px",
                marginTop: innerHexSize / 15 + "px",
                marginBottom: "10px"
              }}
            >
              {isDistribution ? (
                <DistributionChartContainer
                  id={id}
                  field={currentField}
                  showAxis={hexSize >= 300}
                  showTitle={hexSize >= 300}
                  color={colors[currentField.rank]}
                />
              ) : (
                <OutcomeChartContainer
                  field={currentField}
                  id={id}
                  isSmall={hexSize < 300}
                  showCorrelation
                  color={colors[currentField.rank]}
                  chart={{ chartType: chartType }}
                />
              )}
            </div>
            {hexSize < 300 && <div className={styles.hexHeader}>{currentField.label}</div>}
          </div>
        )}
      </div>
    );
  }

  renderVotingChart(node) {
    const { innerHexSize, hexSize } = this.props;

    if (node?.chart?.chart?.series?.[0]?.type != "HeatMap") {
      return this.renderNextChart(node);
    }

    return (
      <div className={styles.hexContent} style={hexSize < 300 ? { flexDirection: "column" } : {}}>
        <div
          className={styles.hexChart}
          style={{
            height: innerHexSize / 1.5 + "px",
            width: innerHexSize / 1.6 + "px",
            marginTop: innerHexSize / 10 + "px"
          }}
        >
          <Heatmap isSmall style={{ height: "75%" }} chart={node.chart} />
          {hexSize < 300 && hexSize > 60 && <div className={styles.hexHeader}>{node?.chart?.narrative?.title}</div>}
        </div>
      </div>
    );
  }

  renderNextChart(node) {
    const { id, innerHexSize, hexSize, comparisonOptions } = this.props;

    if (node?.chart?.chart?.series?.[0]?.type == "HeatMap") {
      return this.renderVotingChart(node);
    }

    return (
      <div
        className={styles.hexContent}
        style={hexSize < 300 ? { flexDirection: "column" } : {}}
        title={node?.chart?.narrative?.title}
      >
        <div
          className={styles.hexChart}
          style={{
            height: hexSize < 60 ? innerHexSize + "px" : innerHexSize / 1.5 + "px",
            width: hexSize < 60 ? innerHexSize / 1.4 + "px" : innerHexSize / 1.6 + "px",
            marginTop: "0px"
          }}
        >
          <NextChartContainer id={id} chart={node.chart} node={node} isSmall={hexSize < 300} isHexagon />
          {hexSize < 300 && hexSize > 60 && (
            <div className={styles.hexHeaderChart} style={{ marginTop: comparisonOptions ? "5px" : undefined }}>
              {comparisonOptions && node?.chart?.narrative?.conditionsLabel
                ? node?.chart?.narrative?.conditionsLabel
                : node?.chart?.narrative?.title}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderDouble(fields, shouldLog) {
    const { id, innerHexSize, hexSize } = this.props;

    return (
      <div className={styles.hexContent} style={hexSize < 300 ? { flexDirection: "column" } : {}}>
        <div
          className={styles.hexChart}
          style={{
            height: innerHexSize / 1.5 + "px",
            width: innerHexSize / 1.5 + "px",
            marginTop: -innerHexSize / 5 + "px",
            marginBottom: "10px"
          }}
        >
          <DoubleOutcomeChartContainer
            id={id}
            fields={fields}
            isSmall={hexSize < 300}
            colorOne={colors[fields[0].rank]}
            colorTwo={colors[fields[1].rank]}
            shouldLog={shouldLog}
          />
        </div>
        {hexSize < 300 && hexSize > 60 && (
          <div className={styles.hexHeader}>
            {fields?.[0]?.label + " when " + fields?.[1]?.label + " is " + fields?.[1]?.data?.[0]?.value}
          </div>
        )}
      </div>
    );
  }

  renderCenter() {
    const { id, hexSize, innerHexSize, comparisonOptions } = this.props;

    const rawSize = hexSize > 300 ? innerHexSize * 1 : innerHexSize * 1.1;

    const size = comparisonOptions ? rawSize * 1.1 : rawSize;

    return (
      <div className={styles.hexContent} style={{ alignItems: "center", overflow: "visible" }}>
        <div
          className={styles.leakageChart}
          style={{
            height: size + "px",
            width: size + "px",
            pointerEvents: "none"
          }}
        >
          {hexSize > 80 ? (
            comparisonOptions ? (
              <ComparisonChartContainer id={id} height={size} width={size} isSmall />
            ) : (
              <LeakageChartContainer id={id} height={size} width={size} isSmall />
            )
          ) : (
            <div className={styles.leakageMsg}>{"Zoom in to View"}</div>
          )}
        </div>
      </div>
    );
  }

  renderDirectionButton() {
    const { node, hexSize } = this.props;

    const firstVariable = node && node.fields && node.fields[0] ? node.fields[0] : {};
    const secondVariable = node && node.fields && node.fields[1] ? node.fields[1] : {};

    const color = firstVariable.color;

    const rHexSize = hexSize / 3;

    const fSizeP =
      hexSize < 60
        ? { display: "none" }
        : hexSize < 100
          ? { fontSize: "8px" }
          : hexSize < 120
            ? { fontSize: "12px" }
            : hexSize < 140
              ? { fontSize: "14px" }
              : { fontSize: "16px" };

    const fSize = { ...fSizeP, color: "white" };

    return node.type === HEXAGON_NODES.DRILL_IN ? (
      <div className={styles.directionContent}>
        <div
          className={styles.hexagon + " " + styles.fIcon + " " + styles.hHolder}
          style={{
            height: rHexSize + 15 + "px",
            width: (rHexSize + 15) * (110 / 190) + "px",
            background: color
          }}
        >
          <div className={styles.face1 + " " + styles.fIcon} style={{ background: color }}></div>
          <div className={styles.face2 + " " + styles.fIcon} style={{ background: color }}></div>
          <img src={FirstVarIcon} />
        </div>
        <div className={styles.dContentSecond} style={fSize}>
          {"Drill-down on " + firstVariable.label}
        </div>
      </div>
    ) : node.type === HEXAGON_NODES.DRILL_IN_CLUSTER ? (
      <div className={styles.directionContent}>
        <div
          className={styles.hexagon + " " + styles.sIcon + " " + styles.hHolder}
          style={{
            height: rHexSize + 15 + "px",
            width: (rHexSize + 15) * (110 / 190) + "px",
            background: color
          }}
        >
          <div className={styles.face1 + " " + styles.sIcon} style={{ background: color }}></div>
          <div className={styles.face2 + " " + styles.sIcon} style={{ background: color }}></div>
          <img src={SecondVarIcon} />
        </div>
        <div className={styles.dContentSecond} style={fSize}>
          {"Benchmark (group by) a specific " + firstVariable.label}
        </div>
      </div>
    ) : node.type === HEXAGON_NODES.FIRST_VARIABLE ? (
      <div className={styles.directionContent}>
        <div
          className={styles.hexagon + " " + styles.fIcon + " " + styles.hHolder}
          style={{
            height: rHexSize + 15 + "px",
            width: (rHexSize + 15) * (110 / 190) + "px",
            background: color
          }}
        >
          <div className={styles.face1 + " " + styles.fIcon} style={{ background: color }}></div>
          <div className={styles.face2 + " " + styles.fIcon} style={{ background: color }}></div>
          <img src={FirstVarIcon} />
        </div>
        <div className={styles.dContentSecond} style={fSize}>
          {"Continue exploring " + firstVariable.label + " insights"}
        </div>
      </div>
    ) : node.type === HEXAGON_NODES.SECOND_VARIABLE ? (
      <div className={styles.directionContent}>
        <div
          className={styles.hexagon + " " + styles.sIcon + " " + styles.hHolder}
          style={{
            height: rHexSize + 15 + "px",
            width: (rHexSize + 15) * (110 / 190) + "px",
            background: secondVariable.color
          }}
        >
          <div className={styles.face1 + " " + styles.sIcon} style={{ background: secondVariable.color }}></div>
          <div className={styles.face2 + " " + styles.sIcon} style={{ background: secondVariable.color }}></div>
          <img src={SecondVarIcon} />
        </div>
        <div className={styles.dContentSecond} style={fSize}>
          {"Skip to learning more about " + secondVariable.label}
        </div>
      </div>
    ) : node.type === HEXAGON_NODES.STAT_ASSOC ? (
      <div className={styles.directionContent}>
        <div
          className={styles.hexagon + " " + styles.hIcon + " " + styles.hHolder}
          style={{
            height: rHexSize + 15 + "px",
            width: (rHexSize + 15) * (110 / 190) + "px"
          }}
        >
          <div className={styles.face1 + " " + styles.hIcon}></div>
          <div className={styles.face2 + " " + styles.hIcon}></div>
          <img src={StatAssocIcon} />
        </div>
        <div className={styles.dContentSecond} style={{ ...fSize, width: "160px" }}>
          {"What is statistically related to " + firstVariable.label}
        </div>
      </div>
    ) : node.type === HEXAGON_NODES.POPULAR ? (
      <div className={styles.directionContent}>
        <div
          className={styles.hexagon + " " + styles.hIcon + " " + styles.hHolder}
          style={{
            height: rHexSize + 15 + "px",
            width: (rHexSize + 15) * (110 / 190) + "px"
          }}
        >
          <div className={styles.face1 + " " + styles.hIcon}></div>
          <div className={styles.face2 + " " + styles.hIcon}></div>
          <img src={PopularIcon} />
        </div>
        <div className={styles.dContentSecond} style={fSize}>
          {"Graphs other users visited after this one"}
        </div>
      </div>
    ) : node.type === HEXAGON_NODES.VOTING ? (
      <div className={styles.directionContent}>
        <div
          className={styles.hexagon + " " + styles.hIcon + " " + styles.hHolder}
          style={{
            height: rHexSize + 15 + "px",
            width: (rHexSize + 15) * (110 / 190) + "px"
          }}
        >
          <div className={styles.face1 + " " + styles.hIcon}></div>
          <div className={styles.face2 + " " + styles.hIcon}></div>
          <img src={VotingIcon} />
        </div>
        <div className={styles.dContentSecond} style={fSize}>
          {"Importance according to different models"}
        </div>
      </div>
    ) : (
      <div />
    );
  }

  renderDirection(node) {
    const { hex, addPinned, updateSelectedHex, updateSelectionDirection } = this.props;

    return (
      <div className={styles.selectedDirection}>
        {node.direction}
        <Button
          onClick={(e) => {
            e.stopPropagation();
            updateSelectedHex(hex);
            updateSelectionDirection(undefined);
          }}
          style={{ padding: "3px", marginLeft: "5px" }}
        >
          {"Back"}
        </Button>
      </div>
    );
  }

  renderShowMore(isShowMore) {
    const { showMore, showLess } = this.props;

    return (
      <div className={isShowMore ? styles.showMore : styles.showLess}>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();

            if (isShowMore) {
              showMore();
            } else {
              showLess();
            }
          }}
          style={{ padding: "3px" }}
        >
          {isShowMore ? "More" : "Less"}
        </Button>
      </div>
    );
  }

  renderFromIcon(node) {
    let sDiv = document.getElementById("hexTile_" + node.x + "_" + node.y + "_a");
    if (sDiv === null || sDiv === undefined) {
      sDiv = document.getElementById("hexTile_" + node.x + "_" + node.y + "_0");
    }

    let fDiv = document.getElementById("hexTile_" + node.fromNode.x + "_" + node.fromNode.y + "_a");
    if (fDiv === null || fDiv === undefined) {
      fDiv = document.getElementById("hexTile_" + node.fromNode.x + "_" + node.fromNode.y + "_0");
    }

    const rHexSize = 40;

    const firstVariable = node && node.fields && node.fields[0] ? node.fields[0] : {};

    if (sDiv && fDiv) {
      const nTop =
        fDiv.offsetLeft === sDiv.offsetLeft
          ? fDiv.offsetTop > sDiv.offsetTop
            ? fDiv.offsetTop - sDiv.offsetTop - 25
            : sDiv.offsetTop - fDiv.offsetTop - 236
          : fDiv.offsetTop > sDiv.offsetTop
            ? 140
            : 35;

      const nLeft = fDiv.offsetLeft === sDiv.offsetLeft ? 55 : fDiv.offsetLeft > sDiv.offsetLeft ? 145 : -50;

      const icon =
        node && node.fromType && node.fromType.type ? this.getIconFromType(node.fromType.type) : FirstVarIcon;

      return (
        <div className={styles.nodeIcon} style={{ top: nTop, left: nLeft }}>
          <div
            className={styles.hexagon + " " + styles.hIcon + " " + styles.hHolder}
            style={{
              height: rHexSize - 3 + "px",
              width: (rHexSize - 3) * (110 / 190) + "px",
              background: firstVariable.color
            }}
          >
            <div className={styles.face1 + " " + styles.hIcon} style={{ background: firstVariable.color }}></div>
            <div className={styles.face2 + " " + styles.hIcon} style={{ background: firstVariable.color }}></div>
            <img src={icon} style={{ transform: "scale(0.5)" }} />
          </div>
        </div>
      );
    }

    return <div />;
  }

  renderAddTodo(node) {
    const { addToDo } = this.props;

    return (
      <div className={styles.todoActions} style={node?.isDirection ? { right: "0px" } : { right: "30px" }}>
        <Button
          style={{ padding: "5px", whiteSpace: "nowrap" }}
          onClick={(e) => {
            e.stopPropagation();
            addToDo(node);
          }}
        >
          {node?.isDirection ? "Add All To Do" : <img src={TodoAddIcon} title="Add To Do" />}
        </Button>
      </div>
    );
  }

  renderActions(node) {
    const {
      hex,
      addPinned,
      selectedChart,
      updateSelectedHex,
      updatePinnedHex,
      addToPinnedHexList,
      hasActions,
      isSelectedActionHex,
      selectionDirection,
      removeAllNodes,
      removeNode,
      replayActions,
      isInHexMap,
      isInReport,
      comparisonOptions,
      addToDo,
      isHighlight
    } = this.props;

    return (
      <div className={styles.nodeActions} style={isSelectedActionHex || isHighlight ? { opacity: 1 } : {}}>
        <ButtonGroup>
          {node && node.isAdded && hasActions !== true && (
            <Button
              style={{ padding: "5px" }}
              onClick={(e) => {
                e.stopPropagation();
                replayActions(node);
              }}
            >
              <FontAwesomeIcon icon={faPlay} />
            </Button>
          )}
          {hasActions && isInReport !== true && isInHexMap !== true && isSelectedActionHex !== true && (
            <Button
              style={{ padding: "5px", whiteSpace: "nowrap" }}
              onClick={(e) => {
                e.stopPropagation();
                addToDo(node);
              }}
            >
              {node?.isDirection ? "Add All To Do" : <img src={TodoAddIcon} title="Add To Do" />}
            </Button>
          )}
          {isInReport && isSelectedActionHex === true ? (
            <div />
          ) : isInReport ? (
            <Button
              id={isSelectedActionHex ? "pinButton" : "notVisiblePin"}
              onClick={(e) => {
                e.stopPropagation();

                return hasActions || comparisonOptions !== undefined ? removeAllNodes(node) : removeNode(hex, node);
              }}
              style={{ padding: "5px" }}
              className={styles.pinButton}
            >
              <OverlayTrigger
                placement={"top"}
                trigger={["hover", "focus"]}
                containerPadding={20}
                overlay={<Popover id={"popover-positioned-top"}>{"Unpin Chart"}</Popover>}
              >
                <img src={PinnedHoverIcon} className={styles.pinHover} />
              </OverlayTrigger>
              <img src={PinnedIcon} className={styles.pinNoHover} />
            </Button>
          ) : (
            <Button
              id={isSelectedActionHex ? "pinButton" : "notVisiblePin"}
              style={{ padding: "5px" }}
              onClick={(e) => {
                e.stopPropagation();

                hasActions || comparisonOptions !== undefined
                  ? updatePinnedHex(hex, node)
                  : addToPinnedHexList({ ...node, ...hex });
              }}
            >
              <img style={{ width: "15px" }} src={UnpinnedIcon} />
            </Button>
          )}
          {isSelectedActionHex && selectionDirection === undefined && (
            <Button
              id="closeButton"
              style={{ padding: "3px" }}
              onClick={(e) => {
                e.stopPropagation();
                addPinned();
              }}
            >
              <div className={styles.selIcon} title="Close">
                <img src={NextClose} />
              </div>
            </Button>
          )}
        </ButtonGroup>
      </div>
    );
  }

  renderDelete(node) {
    const { hex, removeNode, replayActions, isInHexMap, isPinned, hasActions, removeAllNodes } = this.props;

    return (
      <div
        className={styles.deleteHolder}
        style={hasActions ? { opacity: 1 } : {}}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {node && node.isAdded && (
          <div className={styles.replayButtonHex}>
            <Button style={{ padding: "7px", marginRight: "5px" }} onClick={() => replayActions(node)}>
              <FontAwesomeIcon icon={faPlay} />
            </Button>
          </div>
        )}
      </div>
    );
  }

  renderNextPrev(node) {
    const { hex, nodes, updateHexOrder, hexOrder } = this.props;

    return (
      <div
        className={styles.nextPrevCenter}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          className={styles.nextPrevIcon}
          onClick={() => updateHexOrder(hex, false)}
          onMouseEnter={() => this.setState({ highlightLeftChevron: true })}
        >
          {/* <FontAwesomeIcon icon={faChevronLeft} /> */}
          {this.state.highlightLeftChevron ? (
            <img style={{ transform: "rotate(180deg)" }} src={HexagonChevronPurple} />
          ) : (
            <img src={HexagonChevronGrey} />
          )}
        </div>
        <div
          className={styles.nextPrevIcon}
          onClick={() => updateHexOrder(hex, true)}
          onMouseEnter={() => this.setState({ highlightRightChevron: true })}
        >
          {this.state.highlightRightChevron ? (
            <img src={HexagonChevronPurple} />
          ) : (
            <img style={{ transform: "rotate(180deg)" }} src={HexagonChevronGrey} />
          )}
          {/* <FontAwesomeIcon icon={faChevronRight} /> */}
        </div>
        <div className={styles.nextPrevCounter}>
          <div className={styles.nextInfo}>{(hexOrder === undefined ? 1 : hexOrder + 1) + " / " + nodes.length}</div>
        </div>
      </div>
    );
  }

  renderSelected(node) {
    const {
      hex,
      nodes,
      resetActions,
      hasPins,
      selectionDirection,
      addPinned,
      updateHexOrder,
      updateSelectionDirection
    } = this.props;

    const nIndex = node.index !== undefined ? node.index : 0;

    return (
      <div
        className={styles.selectActions}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Button style={{ padding: "3px" }} onClick={() => addPinned()}>
          <div className={styles.selIcon} title="Close">
            <img src={NextClose} alt={"Close"} />
          </div>
        </Button>
      </div>
    );
  }

  /*

  renderShowMore(isShowMore) {
    const { showMore, showLess } = this.props;

    return (
      <div className={isShowMore ? styles.showMore : styles.showLess}>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();

            if (isShowMore) {
              showMore();
            } else {
              showLess();
            }
          }}
          style={{ padding: "3px" }}
        >
          {isShowMore ? "More" : "Less"}
        </Button>
      </div>
    );
  }
  */
  renderBack(node) {
    const {
      hex,
      nodes,
      resetActions,
      hasPins,
      selectionDirection,
      addPinned,
      updateHexOrder,
      updateSelectionDirection,
      showMore,
      showLess,
      totalChartCount,
      viewIndex
    } = this.props;

    const nIndex = node.index !== undefined ? node.index : 0;

    const vCharts = Math.min(viewIndex + 6, totalChartCount);

    return (
      <div
        className={styles.selDirectionActions}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className={styles.selectActionsBack}>
          <Button
            style={{
              padding: "3px",
              visibility: selectionDirection ? "visible" : "hidden"
            }}
            disabled={selectionDirection === undefined}
            onClick={() => updateSelectionDirection(selectionDirection)}
          >
            <div className={styles.selIcon} title="Back">
              <img src={BackIcon} />
            </div>
          </Button>
          <Button style={{ padding: "3px" }} onClick={() => addPinned()}>
            <div className={styles.selIcon} title="Close">
              <img src={NextClose} />
            </div>
          </Button>
        </div>
        <div className={styles.showMoreActions}>
          <div className={styles.showLess}>
            <Button onClick={(e) => showLess()} style={{ padding: "3px" }} disabled={viewIndex === 0}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </Button>
          </div>
          <div className={styles.showCount}>{vCharts + " / " + totalChartCount}</div>
          <div className={styles.showMore}>
            <Button onClick={(e) => showMore()} style={{ padding: "3px" }} disabled={viewIndex + 6 >= totalChartCount}>
              <FontAwesomeIcon icon={faChevronRight} />
            </Button>
          </div>
        </div>
      </div>
    );
  }

  renderBackDiff(node) {
    const {
      hex,
      nodes,
      resetActions,
      hasPins,
      selectionDirection,
      addPinned,
      updateHexOrder,
      updateSelectionDirection,
      showMore,
      showLess,
      totalChartCount,
      viewIndex
    } = this.props;

    const nIndex = node.index !== undefined ? node.index : 0;

    const vCharts = Math.min(viewIndex + 6, totalChartCount);

    return (
      <div
        className={styles.selDirectionActions}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className={styles.showMoreActions + " " + styles.showDiff}>
          <div className={styles.showLessDiff}>
            <Button onClick={(e) => showLess()} style={{ padding: "3px" }} disabled={viewIndex === 0}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </Button>
          </div>
          <div className={styles.showCountDiff}>{vCharts + " / " + totalChartCount}</div>
          <div className={styles.showMoreDiff}>
            <Button onClick={(e) => showMore()} style={{ padding: "3px" }} disabled={viewIndex + 6 >= totalChartCount}>
              <FontAwesomeIcon icon={faChevronRight} />
            </Button>
          </div>
        </div>
      </div>
    );
  }

  renderScoreRank(node) {
    const { id } = this.props;

    return (
      <div className={styles.scoreRankMuscle}>
        <div className={styles.tinyMuscleChart}>
          <LeakageChartContainer id={id} height={110} width={110} node={node} isTiny innerRadius={12} />
          <div className={styles.listRankCircle}>{node?.chart?.scoreRank + 1}</div>
        </div>
      </div>
    );
  }

  renderScoreRankOld(node) {
    const { hex } = this.props;

    const background = node?.fields[0] ? node?.fields[0].color : "#7e69d7";

    const rHexSize = 30;

    const icon = node && node.parent && node.parent.type ? this.getIconFromType(node.parent.type) : FirstVarIcon;

    if (!isFinite(node?.chart?.scoreRank)) {
      return <div />;
    }

    return (
      <div className={styles.scoreRank}>
        <div className={styles.scoreRankNum}>{node?.chart?.scoreRank + 1}</div>
        <div
          className={styles.hexagon + " " + styles.hIcon + " " + styles.hHolder}
          style={{
            height: rHexSize - 3 + "px",
            width: (rHexSize - 3) * (110 / 190) + "px",
            marginLeft: "10px",
            background: background
          }}
        >
          <div className={styles.face1 + " " + styles.hIcon} style={{ background: background }}></div>
          <div className={styles.face2 + " " + styles.hIcon} style={{ background: background }}></div>
          <img src={icon} style={{ transform: "scale(0.5)" }} />
        </div>
      </div>
    );
  }

  renderIsInHexMap() {
    return (
      <div className={styles.pExists} title="In Report">
        <Button style={{ padding: "3px" }}>
          <img src={PinnedIcon} className={styles.pExistsIcon} />
        </Button>
      </div>
    );
  }

  pointToHex(x, y) {
    const { hexSize } = this.props;

    const Hex = extendHex({
      size: hexSize, // default: 1
      orientation: "flat" // default: 'pointy'
    });

    const Grid = defineGrid(Hex);

    return Grid.pointToHex(x, y);
  }

  renderDragHex() {
    return <div className={styles.dragHex}>{"Place Graph Here"}</div>;
  }

  renderAddJob() {
    const { updateIsCreateJob } = this.props;

    return (
      <div
        className={styles.cTitleHex}
        onClick={(e) => {
          e.stopPropagation();
          updateIsCreateJob(true);
        }}
      >
        {"Post a New Job Automagically"}
        <div className={styles.cSmall}>{"(Marketplace)"}</div>
      </div>
    );
  }

  renderConsultant(node) {
    const { history, viewConsultants } = this.props;

    return (
      <div
        className={styles.cTitleHex}
        onClick={(e) => {
          e.stopPropagation();
          viewConsultants();
        }}
      >
        {node?.text}
        <div className={styles.cSmall}>{node?.cText !== undefined ? node?.cText + "% Match" : "(Hire Consultant)"}</div>
      </div>
    );
  }

  scrollToMuscle() {
    const { scrollReportByTitle } = this.props;

    scrollReportByTitle(0);

    // document.getElementById("leftPanel") &&
    //   document
    //     .getElementById("leftPanel")
    //     .scrollTo({ top: 0, behavior: "smooth" });
  }

  renderRelate(node) {
    const pType = node?.parent?.type;

    const background =
      pType === HEXAGON_NODES.SECOND_VARIABLE && node?.fields?.[0]?.color
        ? node?.fields?.[0]?.color
        : node?.parent?.fields?.[0]?.color !== undefined
          ? node?.parent?.fields?.[0]?.color
          : "rgb(126, 105, 215)";
    const icon = this.getIconFromType(pType);

    return (
      <div className={styles.scoreRank}>
        <div className={styles.relateBox} style={{ background: background }}>
          <div className={styles.scoreRankNum}>{node?.rIndex + 1}</div>
          <img className={styles.relateIcon} src={icon} />
          {node?.fromType?.type === "Statistical Association" && node?.chart?.score !== undefined && (
            <div className={styles.scoreRankNum} style={{ marginLeft: "8px" }}>
              {node?.chart?.score === 0
                ? "0.0"
                : node?.chart?.score < 0.01
                  ? node?.chart?.score.toFixed(3)
                  : node?.chart?.score.toFixed(2)}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderTinyScore(node) {
    const { id } = this.props;

    return (
      <div className={styles.tinyMuscleScoreHex}>
        <LeakageChartContainer id={id} height={110} width={110} innerRadius={13} node={node} isTiny hideChords />
        <div className={styles.tinyScoreHex}>{node?.chart?.scoreRank + 1}</div>
      </div>
    );
  }

  render() {
    const {
      id,
      hex,
      cProps,
      hexagonRadius,
      getPoint,
      hasActions,
      isMini,
      isFaded,
      isSearch,
      isSelectedActionHex,
      isInHexMap,
      left,
      top,
      node,
      nodes,
      moveHex,
      hexOrder,
      aTimeout,
      hexSize,
      onClick,
      isDragHex,
      resetActions,
      selectedHex,
      selectionDirection,
      stopAnimation,
      useLocation,
      updateSelectedHex,
      updateSelectionDirection,
      updateSelectedChart,
      updateSearchChart,
      updateHover,
      updateViewIndex,
      updateDragHex,
      isPinned,
      isExploreReady,
      isAnimateReturn,
      isLastMoveChart,
      isInReport,
      isHighlight,
      comparisonOptions
    } = this.props;

    const { isHover, isAnimate } = this.state;

    if (node === undefined) {
      return <div />;
    }

    const hKey = hex ? hex.x + "_" + hex.y : "";

    const isEmpty = false;

    const tNodes = nodes ? [...nodes] : [node];

    const rNodes =
      hexOrder === undefined && tNodes.length === 1
        ? tNodes
        : tNodes
            .map((n, i) => ({ ...n, index: i }))
            .sort((a, b) => {
              const rHexOrder = hexOrder === undefined ? 0 : hexOrder;

              if (a.index === rHexOrder) {
                return 1;
              }
              if (b.index === rHexOrder) {
                return -1;
              }

              return 0;
            });

    const opacity =
      isHover && node?.type === HEXAGON_NODES.MUSCLE && rNodes.length === 1
        ? 1.0
        : isFaded
          ? 0.3
          : hasActions && node.isAction !== true && isSelectedActionHex !== true
            ? 0
            : 1;

    const renderHex = isMini ? (
      <div />
    ) : (
      <div className={styles.oTrans} style={isAnimateReturn ? { pointerEvents: "none" } : {}}>
        {rNodes &&
          rNodes.map((node, i) => {
            const fields = node?.fields || {};

            const isDirectionNode =
              node &&
              node.direction === undefined &&
              (DIRECTION_NODES.indexOf(node.type) !== -1 || DIRECTION_NODES_SINGLE.indexOf(node.type) !== -1);

            const parentLoc =
              isAnimateReturn && node?.sParent && getPoint !== undefined
                ? getPoint(node?.sParent?.x, node?.sParent?.y)
                : isPinned && node?.parent && getPoint !== undefined
                  ? getPoint(node?.parent?.x, node?.parent?.y)
                  : node?.aParent !== undefined && getPoint !== undefined
                    ? getPoint(node?.aParent?.x, node?.aParent?.y)
                    : undefined;

            const isFirstChart = i === rNodes.length - 1;

            return (
              <InnerHexagon
                comparisonOptions={comparisonOptions}
                aTimeout={aTimeout === undefined ? undefined : aTimeout + i * 500}
                stopAnimation={stopAnimation}
                useLocation={useLocation}
                node={node}
                getPoint={getPoint}
                id={
                  "hexTile_" +
                  hKey +
                  "_" +
                  node?.chart?.narrative?.title +
                  "_" +
                  (node.isAction ? "a" : rNodes.length - i - 1)
                }
                retId={"hexTile_" + hKey + "_" + (node.isAction ? "a" : rNodes.length - i - 1)}
                isFirstChart={isFirstChart}
                isAnimate={node?.isAnimate || isLastMoveChart}
                nextId={id}
                onClick={
                  onClick
                    ? onClick
                    : isSearch
                      ? () => updateSearchChart(hex, node)
                      : node && node.type === HEXAGON_NODES.MUSCLE
                        ? () => {
                            resetActions();
                            this.scrollToMuscle();
                          }
                        : isDirectionNode && selectionDirection?.type === node?.type
                          ? () => {}
                          : isDirectionNode
                            ? () => updateSelectionDirection(node)
                            : hasActions === true
                              ? (e) => {
                                  e.stopPropagation();
                                  updateSelectedChart(hex, node);
                                }
                              : (e) => {
                                  e.stopPropagation();
                                  updateSelectedHex(hex, node);
                                }
                }
                /* TODO: Shouldn't use window but it's OK here
                  since it's only for more efficient hover */
                onMouseEnter={() => {
                  if (window?.setHoverTimeout !== undefined) {
                    clearTimeout(window.setHoverTimeout);
                    window.setHoverTimeout = undefined;
                  }

                  updateHover(node);
                }}
                onMouseLeave={() => {
                  if (window) {
                    if (window.setHoverTimeout === undefined) {
                      window.setHoverTimeout = setTimeout(() => {
                        updateHover(undefined);
                      }, 30);
                    }
                  } else {
                    updateHover(undefined);
                  }
                }}
                updateHover={updateHover}
                zIndex={
                  isSelectedActionHex && selectionDirection !== undefined && node.isAction !== true
                    ? 4
                    : node?.isDirection
                      ? 110
                      : isHighlight && selectionDirection === undefined
                        ? 200
                        : isHighlight
                          ? 100
                          : node.isAction && selectionDirection === undefined
                            ? 40
                            : node.isAction && selectionDirection !== undefined
                              ? 105
                              : this.props.zIndex !== undefined
                                ? this.props.zIndex
                                : node?.type === HEXAGON_NODES.MUSCLE && hasActions === false && rNodes?.length === 1
                                  ? 60
                                  : isHover && node?.type !== HEXAGON_NODES.MUSCLE
                                    ? 50
                                    : node?.y !== undefined
                                      ? 5 + node?.y
                                      : 5
                }
                key={"hex_" + hKey + "_" + i + (node.isAction ? "a" : i)}
                className={useLocation ? styles.hexHolderLoc : styles.hexHolder}
                left={
                  isAnimateReturn && parentLoc
                    ? parentLoc?.x
                    : left + (isSelectedActionHex || (node.isAction && hasActions) ? 0 : rNodes.length - 1 - i * 5)
                }
                top={
                  isAnimateReturn && parentLoc
                    ? parentLoc?.y
                    : top + (isSelectedActionHex || (node.isAction && hasActions) ? 0 : rNodes.length - 1 - i * 5)
                }
                draggable={
                  isSelectedActionHex === true ? false : hasActions === false && node?.type !== HEXAGON_NODES.MUSCLE
                }
                isSelectedActionHex={isSelectedActionHex}
                onDrag={(e) => {
                  e.preventDefault();

                  const x =
                    e.pageX +
                    document.getElementById("mainScroll").scrollLeft -
                    document.getElementById("leftPanel").offsetWidth +
                    40;
                  const y = e.pageY + document.getElementById("mainScroll").scrollTop - 170;

                  const point = this.pointToHex(x, y);

                  updateDragHex(point);
                }}
                nextChart={node?.chart ? this.renderNextChart(node) : <div />}
                onDragEnd={(e) => {
                  e.preventDefault();

                  const x =
                    e.pageX +
                    document.getElementById("mainScroll").scrollLeft -
                    document.getElementById("leftPanel").offsetWidth +
                    40;
                  const y = e.pageY + document.getElementById("mainScroll").scrollTop - 170;

                  const point = this.pointToHex(x, y);

                  this.setState({ dragHex: undefined });

                  return moveHex(hex, point, node);
                }}
              >
                {node?.type === HEXAGON_NODES.ADD_JOB && this.renderAddJob()}
                {node?.type === HEXAGON_NODES.CONSULTANT && this.renderConsultant(node)}
                {isDragHex && this.renderDragHex()}
                {/*
                {((node.isAction !== true &&
                  hasActions === false &&
                  node.type !== "Muscle Chart") ||
                  isInHexMap ||
                  isPinned) &&
                  this.renderDelete(node)}
                */}
                {rNodes &&
                  rNodes.length > 1 &&
                  node.isAction !== true &&
                  hasActions === false &&
                  this.renderNextPrev(node, i)}

                {hasActions === true && node?.isAction && node?.chart !== undefined && this.renderRelate(node)}

                {node.isAdded !== true &&
                  node?.aParent === undefined &&
                  hasActions !== true &&
                  hexSize > 80 &&
                  node.isSearch !== true &&
                  ((node.isAction && node?.chart?.scoreRank !== undefined) ||
                    (node.fields &&
                      Object.keys(node.fields).length === 1 &&
                      node.isAction !== true &&
                      this.renderTinyScore(node)))}
                {node && node.direction !== undefined && this.renderDirection(node)}
                {node &&
                  node.parent &&
                  hasActions &&
                  node.isDirection === true &&
                  selectionDirection !== undefined &&
                  (selectedHex.x !== hex.x || selectedHex.y !== hex.y) &&
                  this.renderBack(node)}
                {selectedHex &&
                  comparisonOptions !== undefined &&
                  node?.type !== "Muscle Chart" &&
                  node?.x === selectedHex?.x &&
                  node?.y === selectedHex?.y &&
                  this.renderBackDiff(node)}
                {/*
                  {node &&
                  node?.isAction === true &&
                  node?.type !== "Expert" &&
                  node?.isDirection !== true &&
                  this.renderAddTodo(node)}
                */}
                {/* From Icon
                {node &&
                  node.fromNode &&
                  i === rNodes.length - 1 &&
                  this.renderFromIcon(node)}
                */}
                {((node && node.parent && hasActions && node.isDirection !== true) ||
                  (isPinned !== true && node?.chart?.title)) &&
                  this.renderActions(node)}
                {this.renderHex(undefined, i, rNodes)}
                {isAnimate === false && i !== rNodes.length - 1 && node.isAction !== true ? (
                  isExploreReady ? (
                    <div />
                  ) : (
                    <LoadingIndicator />
                  )
                ) : node && node.type === HEXAGON_NODES.VOTING_CHART ? (
                  this.renderVotingChart(node)
                ) : node && node.type === HEXAGON_NODES.TEXT && hexSize > 60 ? (
                  <div className={styles.selectedDirection}>{node.text}</div>
                ) : isDirectionNode ? (
                  this.renderDirectionButton()
                ) : node && node.type === HEXAGON_NODES.MUSCLE ? (
                  this.renderCenter()
                ) : node && "chart" in node ? (
                  i === rNodes.length - 1 ? (
                    <div />
                  ) : (
                    <div />
                  )
                ) : fields && Object.keys(fields).length === 1 ? (
                  this.renderFirst(fields[0])
                ) : fields && Object.keys(fields).length === 2 && fields[0] && fields[1] ? (
                  this.renderDouble(fields, false)
                ) : isExploreReady ? (
                  <div />
                ) : isDragHex === true ? (
                  <div />
                ) : (
                  <LoadingIndicator />
                )}
              </InnerHexagon>
            );
          })}
      </div>
    );

    const miniHex = isMini ? (
      <div
        id={"miniHexTile_" + hKey}
        key={"hex_" + hKey}
        className={styles.hexHolder}
        style={{ left: left, top: top, opacity: opacity }}
      >
        {this.renderMiniHex(
          nodes && nodes.length > 0 && nodes[0]?.fields ? nodes[0]?.fields : node?.fields ? node?.fields : {}
        )}
      </div>
    ) : (
      <div />
    );

    return isMini ? miniHex : renderHex;
  }
}
